// All keys are scoped by organization id so that two cafés using the
// same device can never see each other's cached data.
const pendingKey = (orgId) => `cafepos_pending_orders_${orgId}`;
const productsKey = (orgId) => `cafepos_cached_products_${orgId}`;

// Save products to local cache
export function cacheProducts(orgId, products) {
  localStorage.setItem(productsKey(orgId), JSON.stringify(products));
}

// Get cached products
export function getCachedProducts(orgId) {
  const data = localStorage.getItem(productsKey(orgId));
  return data ? JSON.parse(data) : [];
}

// Save a pending order locally when offline
export function savePendingOrder(orgId, order, items) {
  const pending = getPendingOrders(orgId);
  pending.push({ order, items, savedAt: new Date().toISOString() });
  localStorage.setItem(pendingKey(orgId), JSON.stringify(pending));
}

// Get all pending orders
export function getPendingOrders(orgId) {
  const data = localStorage.getItem(pendingKey(orgId));
  return data ? JSON.parse(data) : [];
}

// Clear pending orders after sync
export function clearPendingOrders(orgId) {
  localStorage.removeItem(pendingKey(orgId));
}
